import React from "react";
import { CircularProgress, Box } from "@mui/material";
export const Spinner = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignitems: "center",
        // minHeight: "100vh",
        // minWidth: "50vw",
        flexDirection: "column",
        marginLeft: "20%",
        marginTop: "5%",
        position: "absolute",
      }}
    >
      <CircularProgress
        size={75}
        color={"inherit"}
      />
    </Box>
  );
};

export default Spinner;
